<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: WUFAN
 * @Date: 2019-12-16
 * @LastEditors: WUFAN
 * @LastEditTime: 2019-12-18
 -->
<template>
  <div class="">
    <!-- <h4 class="login-title">  请输入账户 </h4> -->
    <el-form class="login-form"
           status-icon
           label-width="0">
    <el-form-item prop="username">
      <p class="head-text">请输入密码</p>
      <el-input size="small"
                @keyup.enter.native="didTapToVerify"
                show-password
                type="password"
                autocomplete="off"
                auto-complete="new-password"
                v-model="password1"
                placeholder="请输入密码">
      </el-input>
      <div class="psw-stronger">
        <p>密码强度</p>
        <el-progress :percentage="percentage" style="width:200px;margin-left:20px;" :show-text="false" :color="customColors"></el-progress>
      </div>

    </el-form-item>
    <el-form-item prop="password">
      <p class="head-text">请再次输入密码</p>
      <el-input size="small"
                @keyup.enter.native="didTapToVerify"
                show-password
                type="password"
                autocomplete="off"
                auto-complete="new-password"
                v-model="password2"
                placeholder="请再次输入密码">
      </el-input>
    </el-form-item>
    <el-form-item prop="code">
      <el-row :span="24">
        <el-col :span="16" style="width:100%">
          <p class="head-text">请输入验证码</p>
          <el-input size="small"
                    @keyup.enter.native="didTapToVerify"
                    :maxlength="6"
                    v-model="code"
                    auto-complete="off"
                    placeholder="请输入验证码">
          </el-input>
        </el-col>
      </el-row>
    </el-form-item>
    <el-form-item>
      <el-button type="primary"
                 size="small"
                 @click.stop.prevent="didTapToVerify"
                 :loading="submitLoading"
                 class="login-submit">重置密码</el-button>
    </el-form-item>
  </el-form>
  </div>
</template>
<script>
import { checkPassword } from '@/framework/util/util'
export default {
  name: 'PswAffirm',
  props: {
    userInfo: {
      type: Object
    },
    retrievePasswordType: {
      type: String
    }
  },
  data() {
    return {
      passwordVerifyList: [],
      lastPassword: '', // 对比后密码
      password1: '',
      password2: '',
      code: '',
      percentage: 0,
      customColors: [
        { color: '#FF0000', percentage: 0 },
        { color: '#FF0000', percentage: 20 },
        { color: '#FF6347', percentage: 40 },
        { color: '#DAA520', percentage: 60 },
        { color: '#FFD700', percentage: 80 },
        { color: '#C0FF3E', percentage: 100 }
      ],
      'submitLoading': false
    }
  },

  components: {},

  mounted: function() {

  },
  watch: {
    password1() {
      let a = checkPassword(this.password1)
      this.percentage = a < 20 ? 20 : a < 40 ? 40 : a < 60 ? 60 : a < 80 ? 80 : 100
    }
  },
  computed: {

  },
  methods: {
    // 点击重置
    didTapToVerify: function() {
      if (!this.funcComparePsw()) {
        this.$message.error('两次密码输入不一致，请重新输入！')
      } else {
        this.$http.post('/self/retrieve-password/reset-password', null, { params: {
          accountId: this.userInfo.id,
          captcha: this.code,
          password: this.lastPassword,
          retrievePasswordType: this.retrievePasswordType
        }}).then(response => {
          this.$message.success('修改成功')
          this.$router.push({ path: '/login' })
        }).catch(error => {
          this.$message.error(error.msg)
        })
      }
    },

    // 对比前后输入的密码
    funcComparePsw: function() {
      if (this.password2 === this.password1) {
        this.lastPassword = this.password1
        return true
      } else {
        return false
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.head-text{
  margin: 0
}

.psw-stronger{
  display: flex;
  flex-direction: row;
  align-items: center;
}

.psw-stronger p{
  margin: 0;
  color: #999;
  font-size: 12px;
}
</style>
